export const ModelTypeEnum = Object.freeze({
    available: "available",
    draw: "draw",
    upload: "upload"
})